const NoTextNavBackground = () => {
  return (
    <section className="pb-16 px-8 md:px-12 bg-red-600 dark:bg-green-800">
      <div></div>
    </section>
  );
};

export default NoTextNavBackground;
